import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Helper } from 'Components';
import i18n from 'i18next';
import { Link } from 'react-router-dom';
import './InvoicesSubTemplate.css';

const formatCell = (props, key) => (props[key] === i18n.t('common:Not Specified') ? '' : props[key]);

const InvoicesSubTemplate = props => (
  <Fragment>
    <tr className="invoices-list__sub-template">
      {props.keys.map(key => (
        <td key={key}>
          {key === 'MaxxamJobNumber' ? (
            <Link to={`/jobs/${props[key]}`}>
              <Helper text={i18n.t('tutorials:invoices.3')}>
                {props[key]}
              </Helper>
            </Link>
          ) : formatCell(props, key)}
        </td>
        ))}
    </tr>
  </Fragment>
);

InvoicesSubTemplate.propTypes = {
  keys: PropTypes.arrayOf(PropTypes.string),
};

export default InvoicesSubTemplate;



// WEBPACK FOOTER //
// ./src/containers/Invoices/InvoicesList/InvoicesTemplate/InvoicesSubTemplate.jsx